import flatten from 'lodash/flatten';

import {createReducer} from '../../../utils/reducer';

import {ExperienceSampling, Medium, Questionnaire} from '../actions';
import {Meditation} from '../../meditations/actions';

const initialState = {};

const parseLessons = lessons => {
    const media = {};

    const add = medium => {
        if (media) media[medium.id] = medium;
    };

    lessons.forEach(({blocks}) => {
        blocks.forEach(({type, config}) => {
            if (type === 'media') {
                add(config);
            } else if (type === 'meditation') {
                config.choices.forEach(add);
            }
        });
    });

    return media;
};

export default createReducer(initialState, {
    [Meditation.initialData]: (state, meditations) => parseLessons(meditations),
    [Questionnaire.update]: (state, questionnaires) => parseLessons(questionnaires),
    [ExperienceSampling.update]: (state, samplings) => {
        const questionnaires = flatten(
            samplings.map(({questionnaires}) => questionnaires.map(({questionnaire}) => questionnaire)),
        );

        return parseLessons(questionnaires);
    },
    [Medium.update]: (state, offline) => {
        const files = {};

        offline.forEach(file => {
            files[file.remote] = file;
        });

        return files;
    },
    [Medium.download.started]: (state, remote) => ({
        [remote]: {
            error: null,
            local: null,
            loaded: 0,
            total: 1,
            remote,
        },
    }),
    [Medium.download.progress]: (state, {remote, loaded, total}) => ({
        [remote]: {
            ...state[remote],
            loaded,
            total,
        },
    }),
    [Medium.download.finished]: (state, {remote, local}) => {
        const {total, ...current} = state[remote];

        return {
            [remote]: {
                ...current,
                loaded: total,
                total,
                local,
            },
        };
    },
    [Medium.download.failed]: (state, {remote, error}) => ({
        [remote]: {
            ...state[remote],
            loaded: 0,
            total: 0,
            error,
        },
    }),
});



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/media.js